import { Navigate } from 'react-router-dom';

export default function ProtectedRoute({ children }) {
  const token = localStorage.getItem('authToken');

  // ❌ No token → redirect
  if (!token) {
    return <Navigate to="/sales-sop" replace />;
  }

  // ✅ Token exists → allow
  return children;
}
